'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _prefix = require('../../utils/prefix');

var _prefix2 = _interopRequireDefault(_prefix);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('checkbutton--');

var CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      role = _ref.role;
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('checkbutton', modifiers({ checked: checked })),
      role: role,
      'aria-checked': checked,
      disabled: disabled
    }, !disabled && onChange && {
      onClick: function onClick() {
        return onChange(!checked);
      }
    }),
    children
  );
};

CheckButton.propTypes = {
  children: _propTypes2.default.node,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  role: _propTypes2.default.string
};

CheckButton.defaultProps = {
  role: 'checkbox' // accessibility purposes
};

exports.default = CheckButton;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/CheckButton/index.js
// module id = 378
// module chunks = 0